// extracted by mini-css-extract-plugin
module.exports = {"container":"UserDetails_container__1Thi8","divider":"UserDetails_divider__1SqqQ","infoContainer":"UserDetails_infoContainer__3Othg","submitBtn":"UserDetails_submitBtn__1GOpz"};